import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../_service/Toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from '../../_service/OrderService';
import { SubscriptionService } from '../../_service/SubscriptionService';
import { LocalstorageService } from '../../_service/LocalstorageService';
import { SessionstorageService } from '../../_service/SessionstorageService';
import { AnalyticsService } from '../../_service/AnalyticsService';
import { Snackbarerrorformat, Snackbarformat } from '../../_theme/snackbarformats';


@Component({
    selector: 'app-PaymentSuccess',
    template: 'PAYMENT SUCCESS',
    standalone: true
})
export class PaymentSuccessComponent implements OnInit {

  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private _toastService: ToastService,
    private _translate: TranslateService,
    private _orderService: OrderService,
    private _subscriptionService: SubscriptionService,
    private _localStorage: LocalstorageService,
    private _sessionStorage: SessionstorageService,
    private _analyticsService: AnalyticsService,
  ) {

  }
  ngOnInit() {
    this.activatedRoute.queryParams.pipe(
    ).subscribe(queryParams => {
      console.log('paymentsuccess queryparams', queryParams);
      const mandatenumber = queryParams.mandatenumber;
      const status = queryParams.status;

      let translation = null
      let snackformat = null

      const returnUrl = this._localStorage.getItem('paymentReturnUrl');
      let url = returnUrl.split("?")[0];
      let params = this.router.parseUrl(returnUrl).queryParams;

      if (!url) {
        url = '/';
        this._orderService.clearNewOrderForms();
      }

      params['status'] = status;

      switch (status) {
        case 'fail':
          translation = { text: 'checkout.the signing of the mandate failed', button: 'common.ok_dismiss' }
          snackformat = Snackbarerrorformat
          break;
        case 'cancel':
          translation = { text: 'checkout.the signing of the mandate was cancelled', button: 'common.ok_dismiss' }
          snackformat = Snackbarerrorformat
          break;
        case 'expired':
          translation = { text: 'checkout.the signing of the mandate was expired', button: 'common.ok_dismiss' }
          snackformat = Snackbarerrorformat
          break;
        case 'success':
          translation = { text: 'checkout.the mandate is successfully created!', button: 'common.ok_dismiss' }
          snackformat = Snackbarformat
          this._translate.get(translation).subscribe(res => {
            this._toastService.open(res.text, res.button, snackformat);
          });
          this._orderService.getLastOrder().subscribe({
            next: (order) => {
              const dedup_key = `purchase_fired_${order.orderid}`;
              if (!this._sessionStorage.getItem(dedup_key)) {
                this._sessionStorage.setItem(dedup_key, '1');
                this._analyticsService.push('purchase', {
                  transaction_id: `${order.orderid}`,
                  affiliation: window.location.hostname.split('.').slice(-2).join('.'),
                  value: order.totalvalue,
                  tax: order.vat,
                  shipping: order.shipping,
                  currency: 'EUR',
                  coupon: order.couponcode || undefined,
                  items: order.orderlines.map((line: any) => ({
                    item_id: line.recipeid ? `recipe-${line.recipeid}` : line.boxid ? `box-${line.boxid}` : line.sku,
                    item_name: line.description,
                    item_category: line.recipeid ? 'recipe' : line.boxid ? 'box' : 'product',
                    price: line.price,
                    quantity: line.quantity
                  }))
                } as any);
              }
              this.router.navigate([url], { queryParams: params });
            },
            error: () => {
              this.router.navigate([url], { queryParams: params });
            }
          });
          return;
      }

      if (translation)
        this._translate.get(translation).subscribe(res => {
          this._toastService.open(res.text, res.button, snackformat);
        });

      this.router.navigate([url], { queryParams: params });

    });
      



  }

}
